/**
 * Internal dependencies
 */
import { isEmpty } from './utils';
import { isPhrasingContent } from './phrasing-content';
/**
 * Browser dependencies
 */

var _window$Node = window.Node,
    ELEMENT_NODE = _window$Node.ELEMENT_NODE,
    TEXT_NODE = _window$Node.TEXT_NODE;
export default function (HTML) {
  var decuDoc = document.implementation.createHTMLDocument('');
  var accuDoc = document.implementation.createHTMLDocument('');
  var decu = decuDoc.body;
  var accu = accuDoc.body;
  decu.innerHTML = HTML;

  while (decu.firstChild) {
    var node = decu.firstChild; // Text nodes: wrap in a paragraph, or append to previous.

    if (node.nodeType === TEXT_NODE) {
      if (!node.nodeValue.trim()) {
        decu.removeChild(node);
      } else {
        if (!accu.lastChild || accu.lastChild.nodeName !== 'P') {
          accu.appendChild(accuDoc.createElement('P'));
        }

        accu.lastChild.appendChild(node);
      } // Element nodes.

    } else if (node.nodeType === ELEMENT_NODE) {
      // BR nodes: create a new paragraph on double, or append to previous.
      if (node.nodeName === 'BR') {
        if (node.nextSibling && node.nextSibling.nodeName === 'BR') {
          accu.appendChild(accuDoc.createElement('P'));
          decu.removeChild(node.nextSibling);
        } // Don't append to an empty paragraph.


        if (accu.lastChild && accu.lastChild.nodeName === 'P' && accu.lastChild.hasChildNodes()) {
          accu.lastChild.appendChild(node);
        } else {
          decu.removeChild(node);
        }
      } else if (node.nodeName === 'P') {
        // Only append non-empty paragraph nodes.
        if (isEmpty(node)) {
          decu.removeChild(node);
        } else {
          accu.appendChild(node);
        }
      } else if (isPhrasingContent(node)) {
        if (!accu.lastChild || accu.lastChild.nodeName !== 'P') {
          accu.appendChild(accuDoc.createElement('P'));
        }

        accu.lastChild.appendChild(node);
      } else {
        accu.appendChild(node);
      }
    } else {
      decu.removeChild(node);
    }
  }

  return accu.innerHTML;
}
//# sourceMappingURL=normalise-blocks.js.map